import {
  all,
  arrayOf,
  bool,
  integer,
  isIn,
  isObject,
  maybe,
  nonNegative,
  number,
  object,
  objectStrict,
  positive,
  string,
  values,
  matrixTest,
  pointTest,
} from '@moleculeone/utils';

import * as Drawing from './const';

export const orderTest = isIn(1, 2, 3);
export const chiralTest = isIn(Drawing.WEDGE, Drawing.DASHED);
export const geomTest = isIn(Drawing.CIS, Drawing.TRANS);
export const positionsTest = values(pointTest);

export const bondTest = objectStrict({
  start: string,
  end: string,
  idx: string,
  order: orderTest,
  type: maybe(chiralTest),
  geometry: maybe(geomTest),
  preview: maybe(bool),
  color: maybe(string),
});

export const atomTest = objectStrict({
  idx: string,
  element: string,
  charge: integer,
  classNum: maybe(integer),
  chirality: maybe(string),
  preview: maybe(bool),
  color: maybe(string),
});

export const molTest = objectStrict({
  positions: positionsTest,
  nextAtom: integer,
  nextBond: integer,
  atoms: values(atomTest),
  bonds: values(bondTest),
  key: maybe(string),
});

export const neighborsChiralityDataTest = values(
  object({
    pos: pointTest,
    type: maybe(chiralTest),
  })
);

export const positionsDataTest = objectStrict({
  mol: molTest,
  neighbors: values(arrayOf(isObject)),
  bondArrays: values(arrayOf(string)),
  groupGraph: values(arrayOf(string)),
  groupPositions: values(positionsTest),
  treePositions: values(positionsTest),
  treeParams: values(
    objectStrict({
      parentPivotIdx: maybe(string),
      parentGroupIdx: maybe(string),
      depth: number,
      alignMatrix: matrixTest,
      cumulativeMatrix: matrixTest,
      radius: positive,
      center: pointTest,
      alignedCenter: pointTest,
      angle: maybe(number),
    })
  ),
  result: positionsTest,
});

export const bboxTest = objectStrict({
  min: pointTest,
  max: pointTest,
  size: pointTest,
});

export const drawnAtomTextValue = arrayOf(
  objectStrict({
    text: string,
    size: pointTest,
    shift: pointTest,
    pivot: bool,
    type: maybe(isIn('sub', 'super')),
  })
);

export const drawnAtomTest = objectStrict({
  idx: string,
  pos: pointTest,
  bbox: bboxTest,
  color: string,
  centerLabel: maybe(
    objectStrict({
      parts: drawnAtomTextValue,
      bbox: bboxTest,
    })
  ),
  sideLabel: maybe(
    objectStrict({
      parts: drawnAtomTextValue,
      bbox: bboxTest,
      shift: pointTest,
    })
  ),
  data: objectStrict({
    explicitValence: all(nonNegative, integer),
    valence: maybe(all(nonNegative, integer)),
    hydrogens: maybe(all(nonNegative, integer)),
  }),
  warnings: arrayOf(string),
});

export const drawnBondTest = objectStrict({
  idx: string,
  start: string,
  end: string,
  data: objectStrict({
    cycle: maybe(arrayOf(string)),
  }),
  warnings: arrayOf(string),
  color: maybe(string),
  center: maybe(
    objectStrict({
      type: maybe(isIn(Drawing.WEDGE, Drawing.DASHED)),
    })
  ),
  left: maybe(objectStrict({})),
  right: maybe(objectStrict({})),
});

export const drawnMolTest = objectStrict({
  atoms: values(drawnAtomTest),
  bonds: values(drawnBondTest),
  bbox: bboxTest,
  key: maybe(string),
});
